export default __webpack_public_path__ + "static/media/selected_tractor_user_manual.730af2cd.svg";